import React from "react";
import { ListGroup, Placeholder } from "react-bootstrap";

const RecentActivityCardSkeleton = () => {
  return Array.from({ length: 3 }).map((_, index) => (
    <ListGroup.Item
      key={index}
      className="border-0 p-0 d-flex flex-column gap-1"
    >
      <Placeholder as="div" animation="wave" className="w-75 mb-1">
        <Placeholder xs={6} className="rounded" />
      </Placeholder>
      <Placeholder as="div" animation="wave" className="w-50 mb-0">
        <Placeholder xs={4} className="rounded" />
      </Placeholder>
    </ListGroup.Item>
  ));
};

export default RecentActivityCardSkeleton;
